import * as React from "react"
import { QueryClient, QueryMeta } from "react-query"
import { PersistQueryClientProvider } from "react-query/persistQueryClient"
import { createWebStoragePersister } from "react-query/createWebStoragePersister"
import { QueryState } from "react-query/lib/core/query"

const PERSISTENT_CACHE_TIME = 1000 * 60 * 30 // 30 minutes, which approximates our average session duration

// For interacting with the React Query cache
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      cacheTime: PERSISTENT_CACHE_TIME, // see: https://tanstack.com/query/v4/docs/plugins/persistQueryClient#how-it-works
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      retry: process.env.NODE_ENV === "development" ? 1 : 3,
    },
  },
})

const persister = createWebStoragePersister({
  storage:
    typeof window !== "undefined"
      ? window?.localStorage || undefined
      : undefined,
})

// React Query context provider that wraps our app
function QueryClientProvider(props: any) {
  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister,
        maxAge: PERSISTENT_CACHE_TIME,
        dehydrateOptions: {
          shouldDehydrateQuery: ({
            state,
            meta,
          }: {
            state: QueryState
            meta?: QueryMeta
          }) => {
            if (state.status === "success") {
              // use a defined meta field called "disableCache" to keep a query out of the localStorage persistence layer
              return !meta?.disableCache
            } else {
              return false
            }
          },
        },
      }}
    >
      {props.children}
    </PersistQueryClientProvider>
  )
}

export { queryClient, QueryClientProvider }
